export default "__VITE_ASSET__pZ_v84qO__"